import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'
// Slice
const initial = {
    catalogs: [],
    materials: {}
}

const slice = createSlice({
    name: 'catalogs',
    initialState: {
        ...initial,
    },
    reducers: {
        addCatalogs: (state, action) => {
            let { catalogs = [] } = action.payload;
            state.catalogs = catalogs;
        },
        addMaterials: (state, action) => {
            let { materials = [] } = action.payload;
            let _materials = _.groupBy(materials, 'categoryId')
            state.materials = { ...state.materials, ..._materials };
        },
        clearCatalogs: (state, action) => {
            state.catalogs = [];
            state.materials = {};
        }
    },
});

export default slice.reducer

// Actions
const { addCatalogs, addMaterials, clearCatalogs } = slice.actions

export const addCatalogsAction = (data = []) => async dispatch => {
    try {
        dispatch(addCatalogs({ catalogs: data }));
    } catch (e) {
        return console.error(e);
    }
}

export const addMaterialsAction = (data = []) => async dispatch => {
    try {
        dispatch(addMaterials({ materials: data }));
    } catch (e) {
        return console.error(e);
    }
}

export const clearCatalogsAction = (data) => async dispatch => {
    dispatch(clearCatalogs());
}